exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".meeting-users .list-user-actions{display:inline-block;position:relative}.meeting-users .list-user-actions .new-badge{float:left;margin-right:.35rem}.meeting-users .list-user-actions span.icon{position:relative;top:3px}", ""]);

// exports
